import http from "./../services/httpService";


export async function getRecurringRules() {
    const resp = await http.get('/recurring_rules/')
    return resp.data
}
